import { render, staticRenderFns } from "./mcp-page.vue?vue&type=template&id=041fe1fc&"
import script from "./mcp-page.vue?vue&type=script&lang=js&"
export * from "./mcp-page.vue?vue&type=script&lang=js&"
import style0 from "./mcp-page.vue?vue&type=style&index=0&id=041fe1fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports